var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MMCard',{attrs:{"showTitle":false}},[_c('template',{slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.tips)+" ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }